import Requisicao from "./RequisicaoService";

class ClienteService {        
    static async cadastro(dados) {        
        return Requisicao.post('cliente', dados);
    }

    static async validaCliente(token) {          
        return Requisicao.post('cliente/validaCliente', {
            token: token
        });
    }

    static async verificarCNPJ(cnpj) {                              
        return Requisicao.post('cliente/verificarCNPJ', {            
            cnpj: cnpj            
        });
    }      
}

export default ClienteService;